import { decorate, injectable, inject } from '@evertel/di'
import { DocumentStore } from './store/DocumentStore'
import { DocumentACLStore } from './store/DocumentACLStore'
import { DocumentSchemaStore } from './store/DocumentSchemaStore'
import { DocumentSchemaRevisionStore } from './store/DocumentSchemaRevisionStore'
import { DocumentTileStore } from './store/DocumentTileStore'
import { action, makeObservable } from 'mobx'

class DocumentStoreManager {
    constructor(
        public documentStore: DocumentStore,
        public documentACLStore: DocumentACLStore,
        public documentSchemaStore: DocumentSchemaStore,
        public documentSchemaRevisionStore: DocumentSchemaRevisionStore,
        public documentTileStore: DocumentTileStore
    ) {
        makeObservable(this, {
            clearAllStores: action
        })
    }

    clearAllStores() {
        this.documentStore.clear()
        this.documentACLStore.clear()
        this.documentSchemaStore.clear()
        this.documentSchemaRevisionStore.clear()
        this.documentTileStore.clear()
    }
}

decorate(injectable(), DocumentStoreManager)
decorate(inject(DocumentStore), DocumentStoreManager, 0)
decorate(inject(DocumentACLStore), DocumentStoreManager, 1)
decorate(inject(DocumentSchemaStore), DocumentStoreManager, 2)
decorate(inject(DocumentSchemaRevisionStore), DocumentStoreManager, 3)
decorate(inject(DocumentTileStore), DocumentStoreManager, 4)

export { DocumentStoreManager }
